import base from "../baseurl";
import token from "../getTk";

const Show = async (userUuid, companyId, positionId, city) => {
  console.log(userUuid, companyId, positionId);
  const tokenA = token.get();

  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });

  const status = await api
    .post("assembly-members/create", {
      json: { userUuid, companyId, positionId, city },
    })
    .json();
  console.log(status);
  return status;
};

export default Show;
